import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_DISABLE } from "./gql";

const useDisableStack = createDefaultMutationHook(STACK_DISABLE);
export const useBulkDisableStack = createBulkMutationHook(STACK_DISABLE);

export default useDisableStack;
